import { newE2EPage } from "@stencil/core/testing";

describe("Loader Component", () => {
    describe("General", () => {
        it("should render a component", async () => {
            const page = await newE2EPage();
            await page.setContent(`<ux-loader></ux-loader>`);
            const el = await page.find("ux-loader");
            expect(el).toHaveClass("hydrated");
        });
        describe("Variants snapshots", () => {
            it("should set variant = loader and match screenshot", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-loader variant="spinner"></ux-loader>`);
                const el = await page.find("ux-loader");
                expect(el).toMatchSnapshot();
            });
            it("should set variant = spinner and match screenshot", async () => {
                const page = await newE2EPage();
                await page.setContent(`<ux-loader variant="horizontal"></ux-loader>`);
                const el = await page.find("ux-loader");
                expect(el).toMatchSnapshot();
            });
        });
    });
});
